import React from "react";
import * as yup from "yup";
import { UploadTextField } from "../../../controls/UploadTextField/UploadTextField";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { NameValidation } from "../../../../models/Name";
import { UploadDatePicker } from "../../../controls/UploadDatePicker/UploadDatePicker";
import { UploadSexSelect } from "../../../controls/UploadSexSelect/UploadSexSelect";

export const StepTitle4 = (t: TFunction) => t("step4.title");
export const StepInstructions4 = (t: TFunction) => t("step4.instructions");
export const StepValidation4 = (t: TFunction) =>
  yup.object({
    patient: yup.object({
      name: NameValidation(t),
      birthdate: yup.mixed().required(t("validation.birthdate.required")),
    }),
  });

interface Step4Props {
  otherPatientId: number;
}

export const Step4: React.FC<Step4Props> = ({ otherPatientId }) => {
  const { t } = useTranslation();

  const familyName = t("step4.familyname")+" *";
  const givenName = t("step4.givenname");
  const middleName = t("step4.middlename");
  const prefix = t("step4.prefix");
  const suffix = t("step4.suffix");
  const birthdate = t("step4.birthdate")+" *";
  const sex = t("step4.sex");
  const otherPatientIdLabel = t("step4.other.patient.id");

  return (
    <>
      <div>
        <UploadTextField
          label={familyName}
          placeholder={familyName}
          name="patient.name.familyName"
          type="text"
          autoFocus
        />
      </div>
      <div>
        <UploadTextField
          label={givenName}
          placeholder={givenName}
          name="patient.name.givenName"
          type="text"
        />
      </div>
      <div>
        <UploadTextField
          label={middleName}
          placeholder={middleName}
          name="patient.name.middleName"
          type="text"
        />
      </div>
      <div>
        <UploadTextField
          label={prefix}
          placeholder={prefix}
          name="patient.name.prefix"
          type="text"
        />
      </div>
      <div>
        <UploadTextField
          label={suffix}
          placeholder={suffix}
          name="patient.name.suffix"
          type="text"
        />
      </div>
      <div>
        <UploadDatePicker label={birthdate} name="patient.birthdate" />
      </div>
      <div>
        <UploadSexSelect label={sex} name="patient.sex" />
      </div>
      <div>
        {otherPatientId === 1 && (
          <UploadTextField
            label={otherPatientIdLabel}
            placeholder={otherPatientIdLabel}
            name="patient.otherid"
            type="text"
          />
        )}
      </div>
    </>
  );
};
